import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { RouterModule } from '@angular/router';

import { EventsHomeModule } from '@app/src/app/components/EventsHome';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { PermissionsModule } from '@app/src/app/permissions';
import { SearchModule } from '@app/src/app/search';
import { SearchContentModule } from '@app/src/app/search-content';

import { LayoutLegacyContentModule } from '@modules/layout/components/layout-legacy-content/layout-legacy-content.module';

import { GenericModule } from '@shared/components/generic';

import { EventsComponent } from './Events.component';

@NgModule({
  imports: [
    // Minga dependencies
    SearchContentModule,
    SearchModule,
    MgFormFieldModule,
    EventsHomeModule,
    LayoutLegacyContentModule,
    GenericModule,
    PermissionsModule,

    // External dependencies
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatCheckboxModule,
  ],
  declarations: [EventsComponent],
  exports: [EventsComponent],
})
export class EventsModule {}
